<template>
  <div class="echartsBox">
    <div class="item">

      <div class="name">{{name}}</div>
      <div class="detail">
        <div>{{address}}</div>
        <div>{{time}}</div>
      </div>
    </div>

    <div class="charts" style='background:#fff'>
      <div class="tips">
        <div class="tipItem">
          <div class="bg click"></div>
          <div class="name">点击次数</div>
        </div>
        <div class="tipItem">
          <div class="bg see"></div>
          <div class="name">查看次数</div>
        </div>
      </div>

      <div id="myCharts" ref="myCharts" style="width: 100%;height:350px;"></div>

      <div class="count">
        <div class="countItem">
          <span class="name">点击次数:</span>
          <span class="number">{{allClickCount}}</span>
        </div>
        <div class="countItem">
          <span class="name">查看次数:</span>
          <span class="number">{{allViewCount}}</span>
        </div>
      </div>

    </div>
  </div>
</template>


<script>
import * as echarts from 'echarts'
import { GetQueryString, loadImageEnd } from '@/utils/utils'
import { getAdvertReport } from '@/api/workBenchApi'
export default {
  name: 'charts',
  data() {
    return {
      myCharts: null,
      headers: {},
      allClickCount: 0,
      allViewCount: 0,
    }
  },
  methods: {
    chartResize() {
      this.myCharts.resize({
        width: document.querySelector('#myCharts').getBoundingClientRect().width,
      })
    },
  },
  created() {
    console.log(echarts)
    this.appKey = decodeURIComponent(GetQueryString('appKey'))
    this.name = decodeURIComponent(GetQueryString('name'))
    this.time = decodeURIComponent(GetQueryString('time'))
    this.address = decodeURIComponent(GetQueryString('address'))
    this.eventKey = decodeURIComponent(GetQueryString('eventKey'))
    this.token = decodeURIComponent(GetQueryString('token'))
    this.advertisingCode = decodeURIComponent(GetQueryString('advertisingCode'))
    this.enterpriseCode = decodeURIComponent(GetQueryString('enterpriseCode'))
    var headerClientInfo = { language: 'CN', eventKey: this.eventKey, appKey: this.appKey, enterpriseCode: this.enterpriseCode, userIdentity: 'ENTERPRISES' }
    this.headers = {
      'x-call-client-info': JSON.stringify(headerClientInfo),
      Authorization: this.token,
    }
    getAdvertReport(this.headers, this.advertisingCode).then((res) => {
      console.log(res)
      let xAxis = []
      let clickAxis = []
      let viewAxis = []

      res.data.forEach((v) => {
        xAxis.push(v.date)
        v.clickNumCount = !!v.clickNumCount ? v.clickNumCount : 0
        v.viewNumCount = !!v.viewNumCount ? v.viewNumCount : 0
        clickAxis.push(v.clickNumCount)
        viewAxis.push(v.viewNumCount)
      })

      console.log(clickAxis, viewAxis)
      this.allClickCount = clickAxis.reduce((p, c) => p + c, this.allClickCount)
      this.allViewCount = viewAxis.reduce((p, c) => p + c, this.allViewCount)

      console.log(this.allClickCount, this.allViewCount)
      this.myCharts = echarts.init(document.querySelector('#myCharts'))

      // 绘制图表
      let options = {
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xAxis,
        },
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          top: '15%',
          left: '2%',
          right: '2%',
          bottom: '2%',
          containLabel: true,
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            data: clickAxis,
            type: 'line',
            areaStyle: {
              color: '#00c4c9',
              opacity: '.3',
            },
            lineStyle: {
              normal: {
                color: '#00c4c9',
              },
            },
          },
          {
            data: viewAxis,
            type: 'line',
            lineStyle: {
              normal: {
                color: '#005AC9',
              },
            },
            areaStyle: {
              color: '#005AC9',
              opacity: '.3',
            },
          },
        ],
      }

      this.myCharts.setOption(options, true)

      window.addEventListener('resize', this.chartResize)
    })
  },
}
</script>


<style lang="less" scoped>
.echartsBox {
  background: #f4f4f4;
  min-height: 100vh;
  padding-top: 10px;
  .item {
    height: 70px;
    background: #fff;
    margin-bottom: 12px;
    text-align: left;
    padding: 12px;
    .name {
      font-size: 15px;
      font-weight: 700;
      color: #262626;
    }
    .detail {
      display: flex;
      justify-content: space-between;
      margin-top: 5px;
      font-size: 14px;
      font-weight: 400;
      color: #8c8c8c;
    }
  }
  .charts {
    padding: 12px 15px;
    height: 100vh;
    .tips {
      display: flex;
      .tipItem {
        display: flex;
        align-items: center;
        margin-right: 20px;
        .bg {
          width: 28px;
          height: 11px;
          margin-right: 5px;
          &.see {
            background: #005ac9;
          }
          &.click {
            background: #00c4c9;
          }
        }
        .name {
          font-size: 12px;
          font-weight: 400;
          color: #262626;
        }
      }
    }

    .count {
      display: flex;
      padding: 0 43px;
      justify-content: space-between;
      .countItem {
        .name {
          font-size: 15px;
          font-weight: 400;
          color: #9e9e9e;
          margin-right: 5px;
        }
        .number {
          font-size: 15px;
          font-weight: 400;
          color: #262626;
        }
      }
    }
  }
}
</style>